export const GET_RECOMMENDATIONS_REQUEST = 'GET_RECOMMENDATIONS_REQUEST';
export const GET_RECOMMENDATIONS_SUCCESS = 'GET_RECOMMENDATIONS_SUCCESS';
export const GET_RECOMMENDATIONS_FAILURE = 'GET_RECOMMENDATIONS_FAILURE';
export const DISMISS_RECOMMENDATIONS_REQUEST = 'DISMISS_RECOMMENDATIONS_REQUEST';
export const DISMISS_RECOMMENDATIONS_SUCCESS = 'DISMISS_RECOMMENDATIONS_SUCCESS';
export const DISMISS_RECOMMENDATIONS_FAILURE = 'DISMISS_RECOMMENDATIONS_FAILURE';
export const OPEN_RECOMMENDATIONS_REQUEST = 'OPEN_RECOMMENDATIONS_REQUEST';
export const OPEN_RECOMMENDATIONS_SUCCESS = 'OPEN_RECOMMENDATIONS_SUCCESS';
export const OPEN_RECOMMENDATIONS_FAILURE = 'OPEN_RECOMMENDATIONS_FAILURE';
